import {avg} from './../../../util/plotHelpers';
import {type SafePoint} from './types';

export type PointReduceFn = (points: {
  x: number;
  y: number[];
  expressionValues?: Record<string, number[]>;
}) => SafePoint;

export const averagePoint = ({
  x,
  y,
  expressionValues,
}: {
  x: number;
  y: number[];
  expressionValues?: Record<string, number[]>;
}) => {
  return {
    x,
    y: avg(y),
    expressionValues: expressionValues
      ? Object.entries(expressionValues).reduce(
          (acc, [key, value]) => {
            acc[key] = avg(value);
            return acc;
          },
          {} as Record<string, number>
        )
      : undefined,
  };
};

export const minPoint = ({
  x,
  y,
  expressionValues,
}: {
  x: number;
  y: number[];
  expressionValues?: Record<string, number[]>;
}) => {
  return {
    x,
    y: Math.min(...y),
    expressionValues: expressionValues
      ? Object.entries(expressionValues).reduce(
          (acc, [key, value]) => {
            acc[key] = Math.min(...value);
            return acc;
          },
          {} as Record<string, number>
        )
      : undefined,
  };
};

export const maxPoint = ({
  x,
  y,
  expressionValues,
}: {
  x: number;
  y: number[];
  expressionValues?: Record<string, number[]>;
}) => {
  return {
    x,
    y: Math.max(...y),
    expressionValues: expressionValues
      ? Object.entries(expressionValues).reduce(
          (acc, [key, value]) => {
            acc[key] = Math.max(...value);
            return acc;
          },
          {} as Record<string, number>
        )
      : undefined,
  };
};
